import { createRequest, RequestConfig } from 'app/common/api';

import { TTerminalProfile } from '../../profiles/core/profiles';
import { TTerminal, TTerminalType } from '../core/terminal';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_terminal',
};
type NewTerminal = Omit<TTerminal, 'id' | 'profile' | 'type'> & {
  profile?: Pick<TTerminalProfile, 'id'>;
  type: Pick<TTerminalType, 'id'>;
};

export const addTerminalRequest = (body: NewTerminal) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
